import { afterNextRender, Component, DOCUMENT, HostListener, inject, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NavComponent } from './nav/nav.component';
import { FooterComponent } from './footer/footer.component';
import { debounceTime, filter, fromEvent, skip } from 'rxjs';
import { DeviceService } from './shared/services/device.service';
import { CanonicalService } from './shared/services/canonical.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly deviceService = inject(DeviceService);
  isAdmin: boolean;

  constructor(router: Router, canonicalService: CanonicalService) {
    router.events
      .pipe(
        skip(1),
        filter((event) => event instanceof NavigationStart)
      )
      .subscribe((e) => (this.isAdmin = e.url.indexOf('admin') > 0));

    afterNextRender({
      earlyRead: () => {
        this.deviceService.windowWidth.set(this.getWindowWidth());
        this.initResizeListener();
      },
    });

    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((e) => {
      this.isAdmin = (e as NavigationEnd).url.indexOf('admin') > 0;
      canonicalService.updateCanonicalUrl();
    });
  }

  private initResizeListener(): void {
    if (typeof window === 'undefined') {
      return;
    }

    // Listen to window resize with debounce
    fromEvent(window, 'resize')
      .pipe(debounceTime(150))
      .subscribe(() => {
        this.deviceService.windowWidth.set(this.getWindowWidth());
      });
  }

  private getWindowWidth(): number {
    return typeof window !== 'undefined' ? window.innerWidth : 1920;
  }
}
